import React, { useState, useEffect } from 'react';
import MbCheckbox from 'components/atoms/MbCheckbox';

const CategoryCheckBox = (props) => {
  const { selectedSeq, selectedSeqs } = props;
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let idx = selectedSeqs.indexOf(selectedSeq);
    if (idx > -1) {
      if (checked !== true) setChecked(true);
    } else {
      if (checked !== false) setChecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps,
  }, [selectedSeqs]);

  const handleOnClick = () => {
    let checkedFlag = true;
    let idx = selectedSeqs.indexOf(selectedSeq);
    if (idx > -1) {
      checkedFlag = false;
      selectedSeqs.splice(idx, 1);
    } else {
      selectedSeqs.push(selectedSeq);
    }

    setChecked(checkedFlag);
  };

  return (
    <MbCheckbox
      key={selectedSeq}
      index={selectedSeq}
      edge="start"
      checked={checked}
      onClick={() => handleOnClick()}
      tabIndex={-1}
      disableRipple
      inputProps={{
        'aria-labelledby': selectedSeq,
      }}
    />
  );
};

export default CategoryCheckBox;
